import { colors } from "../../data/colors";
import { stdObject } from "../../data/types/stdObject";
import { checkIfObject } from "../../utils/checkIfObject";
import BasicButton from "../BasicButton";

export default function MenuList({
  tabs = [],
  switchTab = () => {},
  tabIndex = 0,
  mainColor,
  buttons,
  style = {},
  active = false,
  docActive,
}: {
  tabs?: Array<any>;
  switchTab?: (index: number) => void;
  tabIndex?: number;
  mainColor: string;
  buttons: Array<stdObject>;
  style?: stdObject;
  active?: boolean;
  docActive: stdObject;
}) {
  return (
    <div
      className="wrapBox"
      style={{ backgroundColor: colors.lightGrey, overflow: "auto", ...style }}
    >
      <table align="center">
        <tbody>
          <tr>
            {tabs
              .filter((e: any) => e)
              .map(
                (e, index) =>
                  e && (
                    <td key={index}>
                      <BasicButton
                        Icon={e.Icon}
                        onClick={() => switchTab(index)}
                        title={e.label}
                        color={
                          tabIndex === index ? mainColor : colors.lightGrey2
                        }
                        style={e.style ?? {}}
                      />
                    </td>
                  ),
              )}
            {(docActive.status === 0 ||
              docActive.issues ||
              docActive.items ||
              active) &&
              buttons.map(
                (e, index) =>
                  checkIfObject(e) &&
                  Object.keys(e).length > 0 && (
                    <td key={index}>
                      <BasicButton
                        Icon={e.Icon}
                        popup={e.popup}
                        onClick={e.onClick ?? (() => {})}
                        title={e.label}
                        color={e.color}
                        style={e.style ?? {}}
                      />
                    </td>
                  ),
              )}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
